import axios from 'axios';
import Api from './Api';

const { CancelToken } = axios;

let cancelRead;
class WipPanelHistoryApi extends Api {
  constructor() {
    super('wip-panels/histories', 'wip-panels/histories');
  }

  async readData(data) {
    if (cancelRead !== undefined) {
      cancelRead();
    }
    const res = await this.read(data, {
      cancelToken: new CancelToken((c) => {
        cancelRead = c;
      }),
    });
    return res;
  }
}
const wipPanelHistoryApi = new WipPanelHistoryApi();

export default wipPanelHistoryApi;
